export const notificationMessages = [
    {
        id: "featureDisabled",
        type: "error",
        message: "This feature is disabled",
        linkText: "Hopefully it will be working soon",
    },
    
    
    
    
    
    // Global
    {
        id: "productUpdateSuccess",
        type: "success",
        message: "Your products have been updated successfully.",
    },
    {
        id: "customerUpdateSuccess",
        type: "success",
        message: "Your customers have been updated successfully.",
    },
    
    
    
    
    
    
    // New Order Form
    {
        id: "plannedSuccess",
        type: "success",
        message: "Your order has been saved to Planned!",
    },
    {
        id: "pendingSuccess",
        type: "success",
        message: "Your order has been submitted to the Plant!",
    },
    {
        id: "plannedError",
        type: "error",
        message: "Your order failed to save as Planned!",
    },
    {
        id: "pendingError",
        type: "error",
        message: "Your order failed to be submitted to the Plant!",
    },
    {
        id: "newOrderCleared",
        type: "warning",
        message: "Your form has properly been cleared!",
    },
    
    
    
    
    
    
    
    // Order Card
    {
        id: "toActive",
        type: "success",
        message: "Order Successfully moved to Active!",
    },
    {
        id: "toActiveError",
        type: "error",
        message: "Order Failed to be moved to Active!",
    },
    {
        id: "return",
        type: "success",
        message: "Order Returned to the Sales Rep",
    },
    {
        id: "returnError",
        type: "error",
        message: "Order Failed to be Returned!",
    },
    {
        id: "toPending",
        type: "success",
        message: "Order successfully moved to Pending!",
    },
    {
        id: "toPendingError",
        type: "error",
        message: "Order Failed to be moved to Pending!",
    },
    {
        id: "orderDeleted",
        type: "success",
        message: "Order successfully Deleted!",
    },
    {
        id: "orderDeletedError",
        type: "error",
        message: "Order Failed to be Deleted!",
    },
    {
        id: "orderDeletedWarning",
        type: "warning",
        message: "Order Missing Key Information to be Deleted!",
    },
    {
        id: "orderWarning",
        type: "warning",
        message: "Order Missing Key Information to perform this task!",
    },
    {
        id: "ordersUpdated",
        type: "success",
        message: "Orders Updated Successfully!",
    },
    {
        id: "ordersUpdatedError",
        type: "error",
        message: "Orders Failed to Update!",
    },
    {
        id: "erpUpdated",
        type: "success",
        message: "ERP Order Number Updated!",
    },
    {
        id: "erpUpdatedError",
        type: "error",
        message: "ERP Order Number Failed to Update!",
    },
    
    
    
    
    
    
    // Customers
    {
        id: "custUpdated",
        type: "success",
        message: "Customers Updated Successfully!",
    },
    {
        id: "custUpdatedError",
        type: "error",
        message: "Customers Failed to Update!",
    },
    {
        id: "custToActive",
        type: "success",
        message: "Customer Moved to Active Successfully!",
    },
    {
        id: "custToActiveError",
        type: "error",
        message: "Customer Failed to be Moved to Active!",
    },
    {
        id: "custToNewRep",
        type: "success",
        message: "Customer Moved to New Sales Rep Successfully!",
    },
    {
        id: "custToNewRepError",
        type: "error",
        message: "Customer Failed to move to New Sales Rep!",
    },
    {
        id: "custShared",
        type: "success",
        message: "Customer Shared Successfully!",
    },
    {
        id: "custSharedError",
        type: "error",
        message: "Customer Failed to be Shared!",
    },
    {
        id: "custDeleted",
        type: "success",
        message: "Customer Deleted Successfully!",
    },
    {
        id: "custDeletedError",
        type: "error",
        message: "Customer Failed to be Deleted!",
    },
    {
        id: "custAdded",
        type: "success",
        message: "Customer Added Successfully!",
    },
    {
        id: "custAddedError",
        type: "error",
        message: "Customer Failed to be Added!",
    },
    {
        id: "custInactive",
        type: "success",
        message: "Customer Successfully Made Inactive!",
    },
    {
        id: "custInactiveError",
        type: "error",
        message: "Customer Failed to be Made Inactive!",
    },
    {
        id: "custBack",
        type: "success",
        message: "Customer Successfully Moved Back to Active!",
    },
    {
        id: "custBackError",
        type: "error",
        message: "Customer Failed to be Moved Back to Active!",
    },
    
    
    
    
    
    // Contract Price
    {
        id: "contractAdded",
        type: "success",
        message: "Contract Price Successfully Added!",
    },
    {
        id: "contractAddedError",
        type: "error",
        message: "Contract Price Failed to be Added!",
    },
    {
        id: "contractDeleted",
        type: "success",
        message: "Contract Price Successfully Deleted!",
    },
    {
        id: "contractDeletedError",
        type: "error",
        message: "Contract Price Failed to be Deleted!",
    },
    
    
    
    
    
    
    // New Customer Form
    {
        id: "newCustAdded",
        type: "success",
        message: "Customer Successfully Submitted to Plant!",
    },
    {
        id: "newCustAddedError",
        type: "error",
        message: "Customer Failed to be Submitted to Plant!",
    },
    
    
    
    
    
    // Profile
    {
        id: "accountUpdated",
        type: "success",
        message: "Account Information Properly Updated!",
    },
    {
        id: "accountUpdatedError",
        type: "error",
        message: "Account Information Failed to Update!",
    },
    {
        id: "repsUpdated",
        type: "success",
        message: "Reps List successfully Updated!",
    },
    {
        id: "repsUpdatedError",
        type: "error",
        message: "Reps List Failed to Update!",
    },
    
    
    
    
    
    
    // Reps Orders
    {
        id: "allOrdersUpdated",
        type: "success",
        message: "Reps Orders Successfully Updated!",
    },
    {
        id: "allOrdersUpdatedError",
        type: "error",
        message: "Reps Orders Failed to Update!",
    },
    
    
    
    
    
    // Rep Customers
    {
        id: "allCustUpdated",
        type: "success",
        message: "Reps Customers successfully Updated!",
    },
    {
        id: "allCustUpdatedError",
        type: "error",
        message: "Reps Customers Failed to Update!",
    },
    
    
    
    
    
    
    // Login
    {
        id: "login",
        type: "success",
        message: "Login Successful!",
    },
    {
        id: "loginError",
        type: "warning",
        message: "Login Failed!",
        linkText: "Check Email and Password!"
    },
    
    
    
    
    
    // Soil
    {
        id: "soilCust",
        type: "success",
        message: "Customers Successfully Loaded!",
    },
    {
        id: "soilCustLocal",
        type: "success",
        message: "Customers Successfully Loaded from Local Storage!",
    },
    {
        id: "soilCustError",
        type: "error",
        message: "Failed to Load Customers!",
    },
    {
        id: "soilUpload",
        type: "success",
        message: "Soil Test Results Successfully Uploaded!",
    },
    {
        id: "soilUploadError",
        type: "error",
        message: "Failed to Upload Soil Test Results!",
    },
    {
        id: "soilRepError",
        type: "error",
        message: "Failed to Connect Reps List!",
    },
    {
        id: "soilExcel",
        type: "success",
        message: "Successfully Read Results Excel!",
    },
    {
        id: "soilExcelError",
        type: "error",
        message: "Failed to Read Excel!",
    },
    {
        id: "soilExcelErrorFile",
        type: "warning",
        message: "No File Selected!",
    },
    {
        id: "soilExcelErrorEmpty",
        type: "warning",
        message: "Selected File is Empty!",
    },
    {
        id: "soilExcelErrorUnexpected",
        type: "error",
        message: "Unexpected Error Occurred!",
    },
    {
        id: "soilExcelFailed",
        type: "error",
        message: "Failed to Parse the Excel File!",
    },
    
    
    
    
    // Pricing
    {
        id: "pricingUpdate",
        type: "success",
        message: "Products Updated!",
    },
    {
        id: "pricingUpdateError",
        type: "error",
        message: "Failed to Update Products",
    },
    {
        id: "pricingAdded",
        type: "success",
        message: "Product Added to Cloud!",
    },
    {
        id: "pricingAddedError",
        type: "error",
        message: "Failed to Add Product!",
    },
    
    
    
    
    {
        id: "userAdded",
        type: "success",
        message: "Account Successfully Created!",
    },
    {
        id: "userFailed",
        type: "error",
        message: "Account Failed to be Created!",
    },
    
    
    
    
    
    
    
    {
        id: "formError",
        type: "error",
        message: "There was an error submitting the form.",
        linkText: "Try again.",
    },
  // Add more as needed...
];
